import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><g><path style={{
      fill: "#73AF00"
    }} d="M473.885,88.279H38.115C17.045,88.403,0,105.517,0,126.617v28.75h512v-28.75   C512,105.517,494.955,88.403,473.885,88.279z" /><rect y={222.46} style={{
      fill: "#73AF00"
    }} width={512} height={67.09} /></g><rect y={155.37} style={{
    fill: "#FFE15A"
  }} width={512} height={67.09} /><path style={{
    fill: "#73AF00"
  }} d="M0,385.376c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345  v-28.739H0V385.376z" /><rect y={289.55} style={{
    fill: "#FFE15A"
  }} width={512} height={67.09} /><path style={{
    fill: "#FF4B55"
  }} d="M8.828,289.548h185.379c4.875,0,8.828-3.953,8.828-8.828V97.107c0-4.875-3.953-8.828-8.828-8.828  H38.115C17.045,88.403,0,105.517,0,126.617v154.102C0,285.596,3.953,289.548,8.828,289.548z" /><path style={{
    fill: "#F5F5F5"
  }} d="M99.335,135.639l-12.758,38.252l-40.322,0.312c-2.21,0.018-3.127,2.838-1.348,4.151l32.438,23.954  l-12.163,38.446c-0.666,2.108,1.734,3.851,3.531,2.566l32.806-23.447l32.806,23.448c1.799,1.286,4.199-0.458,3.531-2.566  l-12.163-38.445l32.438-23.954c1.779-1.313,0.862-4.135-1.348-4.151l-40.322-0.312L103.7,135.641  C103,133.543,100.034,133.543,99.335,135.639z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };